module.exports = __webpack_public_path__ + "static/media/dancing-cock.a2fd915a.png";